// extracted by mini-css-extract-plugin
export var resizer = "_hk-0";